<template>
  <div>
    <!-- Fehlermeldung -->
    <v-alert v-if="saveStatus === 'failure'" type="error">
      Speichern fehlgeschlagen! Bitte erneut versuchen.
    </v-alert>

    <!-- Erfolgsmeldung -->
    <v-alert v-if="saveStatus === 'success'" type="success">
      Speichern war erfolgreich!
    </v-alert>

    <incidentReportQrCodeChooseType
      v-if="!formHidden && !hasType"
      @choose="handleChooseType"
    />

    <!-- Short form -->
    <incidentReportQrCodeFormShort
      v-if="!formHidden && type === 'short'"
      @saveSuccess="handleSaveSuccess"
      @saveFailure="handleSaveFailure"
      ref="qrCodeFormShort"
    />

    <!-- Long form -->
    <incidentReportQrCodeFormLong
      v-if="!formHidden && type === 'long'"
      @saveSuccess="handleSaveSuccess"
      @saveFailure="handleSaveFailure"
      ref="qrCodeFormLong"
    />

    <!-- Quick form -->
    <incidentReportQrCodeFormQuick
      v-if="!formHidden && type === 'quick'"
      @saveSuccess="handleSaveSuccess"
      @saveFailure="handleSaveFailure"
      ref="qrCodeFormQuick"
    />
  </div>
</template>

<script>
import incidentReportQrCodeFormShort from "./incidentReportQrCodeFormShort.vue";
import incidentReportQrCodeFormLong from "./incidentReportQrCodeFormLong.vue";
import incidentReportQrCodeFormQuick from "./incidentReportQrCodeFormQuick.vue";
import incidentReportQrCodeChooseType from "./incidentReportQrCodeChooseType.vue";

export default {
  name: "incidentReportQrCode",
  components: {
    incidentReportQrCodeFormShort,
    incidentReportQrCodeFormLong,
    incidentReportQrCodeFormQuick,
    incidentReportQrCodeChooseType,
  },
  data() {
    return {
      saveStatus: null,
      formHidden: false,
      type: null,
    };
  },
  computed: {
    hasType() {
      return ["short", "long", "quick"].includes(this.type);
    },
  },
  mounted() {
    const t = (this.$route.query.type || "").toString().toLowerCase();
    if (["short", "long", "quick"].includes(t)) this.type = t;
  },
  watch: {
    "$route.query.type": {
      immediate: false,
      handler(newVal) {
        const t = (newVal || "").toString().toLowerCase();
        if (["short", "long", "quick"].includes(t)) {
          this.type = t;
          this.saveStatus = null;
          this.formHidden = false;
        }
      },
    },
  },
  methods: {
    handleChooseType(type) {
      this.$router.replace({
        query: { ...this.$route.query, type },
      });
      this.type = type;
    },
    handleSaveSuccess() {
      this.saveStatus = "success";
      this.formHidden = true;
    },
    handleSaveFailure() {
      this.saveStatus = "failure";
      this.formHidden = false;
    },
  },
};
</script>
